<template>
  <div class="box">
    <router-view></router-view>
    <transition name="preloader-fade">
      <div class="preloader" v-show="preloader_flag"></div>
    </transition>
    <alert-modal></alert-modal>
  </div>
</template>

<script>
import AlertModal from '@/pages/components/AlertModal'

export default {
  data () {
    return {
      preloader_flag: false,
      alert_modal_flag: false,
      event_bus_alert_modal: '',
      event_bus_preloader_active: ''
    }
  },
  components: {
    AlertModal
  },
  mounted () {
    this.event_bus_preloader_active = this.$geb.getFilteredBus({id: 'preloader'}).subscribe(eventData => {
      this.preloader_flag = eventData.eventData
    })
  },
  beforeDestroy () {
    if (this.event_bus_preloader_active) {
      this.event_bus_preloader_active.unsubscribe()
    }

    if (this.event_bus_alert_modal) {
      this.event_bus_alert_modal.unsubscribe()
    }
  }
}
</script>

<style lang="scss" scoped>
  .preloader {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    overflow: visible;
    background: #333 url('../assets/loading.gif') no-repeat center center;
  }

  .preloader-fade-leave-active{
		transition: opacity .5s
	}

	.preloader-fade-enter-active{
		transition: opacity .5s
	}

	.preloader-fade-enter, .preloader-fade-leave-to{
		opacity: 0
	}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue